import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "36",
  height: "13"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  fill: "none",
  "fill-rule": "evenodd"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#00579F",
    d: "M10.555 1.007 7.777 8.63 7.48 7.08a8.87 8.87 0 0 0-3.93-4.667l2.54 9.76h3.003L13.56 1.008h-3.005m2.379 11.17L14.71.998h2.84l-1.777 11.18h-2.838M26.067 1.273a6.9 6.9 0 0 0-2.543-.471c-2.808 0-4.781 1.517-4.798 3.687-.018 1.612 1.41 2.506 2.486 3.042 1.106.548 1.476.9 1.472 1.389-.01.746-.886 1.087-1.701 1.087-1.133 0-1.738-.166-2.667-.587l-.368-.174-.397 2.5c.663.316 1.888.582 3.163.599 2.98 0 4.917-1.501 4.94-3.822.012-1.273-.746-2.24-2.386-3.038-.988-.517-1.602-.86-1.592-1.386.002-.464.514-.96 1.628-.96a4.8 4.8 0 0 1 2.123.429l.253.13zm7.275-.265H31.15c-.68 0-1.189.201-1.49.928L25.449 12.18h2.983s.487-1.377.596-1.68l3.632.006c.088.391.347 1.674.347 1.674h2.635zm-3.498 7.206c.238-.641 1.132-3.125 1.132-3.125-.018.03.23-.648.377-1.067l.19.966s.545 2.668.657 3.226z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#FAA619",
    d: "M5.201 1.003H.624l-.026.192c3.558.925 5.905 3.202 6.881 5.887l-.992-5.136c-.17-.71-.67-.917-1.286-.943"
  })
], -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }